<template>
  <!-- 大事记时间线详情内容 -->
  <div class="table-container">
    <div v-if="detaiLoading" class="table-spinner">
      <b-spinner
        variant="primary"
        :aria-hidden="false"
        label="正在请求网页"
      ></b-spinner>
    </div>
    <div v-else class="content-html">
      <div v-for="(item, i) in aboutUsList" v-bind:key="i" style="margin-bottom:20px;">
        <h4 class="text-color" style="font-weight:normal">
          {{ item.title }}
        </h4>
        <div :class="local === 'zh' ? 'content-html-img content-html-img-zh' : 'content-html-img content-html-img-en'"  v-html="item.content"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { timelineList } from "../../../api/aboutUs";

export default {
  components: {},
  data() {
    return {
      // this.$t("aboutUs")
      aboutUsList: {},
      detaiLoading: false,
      local: localStorage.getItem("languageSet") || "zh",
    };
  },
  created() {
    this.timelineListApi();
  },
  methods: {
    timelineListApi() {
      const { id } = this.$route.params;
      const params = {
        timeline_id: id,
      };
      this.detaiLoading = true;
      id &&
        timelineList(params).then((res = {}) => {
          this.detaiLoading = false;
          this.aboutUsList = res.list || [];
        });
    },
  },
  watch: {
    $route() {
      this.timelineListApi();
    },
  },
};
</script>

<style scoped>
.table-container {
  position: relative;
  width: 100%;
  min-height: 50vh;
}
.table-container .table-spinner {
  /* this assumes that the spinner component has a width and height */
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 10; /* make sure spinner is over table */
}
</style>
